<template>
  <div variant="custom" v-bind="$attrs">
    <div
      class="[tab-size:4] gap-1.5 [font-variation-settings:var(--default-font-variation-settings,_normal)] font-normal [direction:ltr] leading-normal text-[14px] font-[&quot;Libre_Franklin&quot;,_sans-serif] antialiased text-[#303133] m-0 border-[0] border-[solid] [box-sizing:inherit] pt-2 pr-0 pl-0 pb-2 -mr-2 items-center flex flex-wrap justify-end sticky bottom-[0] left-[0] min-h-[55px] bg-[#fff] border-t-[1px_solid_#ddd] overflow-hidden rounded-tl-none rounded-tr-none border-l-[0] border-r-[0] [box-shadow:none] border-b-[0]"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFeatureFlags } from "@/composables/useFeatureFlags";

const { isEnabled: checkEnabled } = useFeatureFlags();
const isEnabled = checkEnabled("dtpCardActions");
/**
 * dtpCardActions - Wrapper component for q-card-actions
 *
 * This component wraps Quasar's q-card-actions to provide consistent styling
 * and potential future customization across the application.
 *
 * Usage:
 * <dtpCardActions align="right">
 *   <dtpBtn label="Cancel" />
 *   <dtpBtn label="OK" />
 * </dtpCardActions>
 *
 * <dtpCardActions align="right" class="bg-white text-teal">
 *   <dtpBtn flat label="OK" v-close-popup/>
 * </dtpCardActions>
 *
 * All props and attributes from q-card-actions are supported via v-bind="$attrs"
 */

defineOptions({
  name: "dtpCardActions",
  inheritAttrs: false,
});
</script>
